module.exports = __webpack_public_path__ + "img/a.61a0ba5f.jpg";